<template>
    <bottom-dialog v-model="completingPurchase" :dialog="!$vuetify.breakpoint.mobile" max-width="550px" persistent>
        <v-card tile elevation="0">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text" style="overflow-y: auto">
                <div class="font-weight-bold fill-width">
                    {{$translate('Complete the purchase')}}
                </div>
            </v-card-title>

            <v-card-text class="text-center">
                <v-progress-circular indeterminate color="primary" size="64" width="2" class="mt-4 mb-2"/>

                <div>
                    {{$translate('Wait for the purchase to be completed...')}}
                </div>
            </v-card-text>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from './BottomDialog.vue';

export default {
    name: 'zoezi-adyen-redirect',

    components: {
        BottomDialog
    },

    data: () => ({
        completingPurchase: false,
        unsubscribeChannel: null
    }),

    watch: {
        redirectResult: {
            immediate: true,
            handler() {
                if (this.redirectResult) {
                    this.completingPurchase = true;
                    // Need to avoid the cart popping up in the user's face
                    this.$store.dispatch('removeCart', {cartName: ''});
                    this.sendDetails();
                    this.setupListener();
                }
            }
        }
    },

    computed: {
        redirectResult() {
            return this.$route.query.redirectResult;
        },
        secret() {
            return this.$route.query.secret;
        },
        channel2() {
            return this.$route.query.channel2;
        }
    },

    methods: {
        unsubscribe() {
            this.unsubscribeChannel?.();
            this.unsubscribeChannel = null;
            this.completingPurchase = false;
            // Remove secret, channel2 and redirectResult from query
            this.$router.replace({ query: {
                ...this.$route.query,
                secret: undefined,
                channel2: undefined,
                redirectResult: undefined
            }});
        },
        sendDetails() {
            const send = (attempt) => {
                let details = { redirectResult: this.redirectResult };
                this.$api.post('/api/adyen/paymentdetails', {details, secret: this.secret}).catch(() => {
                    console.log('Failed to send payment details')
                    if(attempt > 0) setTimeout(() => send(attempt - 1), 10000);
                });
            }
            send(3);
        },
        setupListener() {
            this.unsubscribeChannel = this.$api.subscribeChannel(this.channel2, (response) => {
                if (response.type == 'adyen:details-status') {
                    // FIXME: The purchase is actually done here
                } else if (response.type === 'adyen:system-error') {
                    this.$store.commit('showSnackBar', {text: 'Köpet avbröts eller kunde inte genomföras'});
                    this.unsubscribe();
                } else if (response.type === 'payment') {
                    if(response.success) {
                        this.$store.commit('showCheckoutDoneDialog', {orderconfirmation: response.orderconfirmation, paidByMethod: null, totalFromServer: null })
                    } else {
                        this.$store.commit('showSnackBar', {text: 'Köpet avbröts eller kunde inte genomföras'});
                    }
                    this.unsubscribe();
                }
            });
        }
    },
    destroyed() {
        this.unsubscribe();
    }
}
</script>
